import { useSuspenseQuery } from '@apollo/client';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { PageBodyContainer } from '@repo/ui/components/layouts/page-body-container.tsx';

import { PageLoader } from '~/components/loader.tsx';
import { NotFound } from '~/components/not-found.tsx';
import { CompleteMemberProfile } from '~/domains/member/components/complete-member-profile.tsx';
import { CurrentUserMembersDocument, CurrentUserMembersQuery } from '~/graphql/types-and-hooks.ts';

export const Route = createFileRoute('/$pathLocale/_layout/_auth/complete-profile')({
  component: RouteComponent,
  notFoundComponent: NotFound,
  pendingComponent: () => (
    <div className="h-screen flex items-center">
      <PageLoader className="size-16" />
    </div>
  ),
});

function RouteComponent() {
  const { t } = useTranslation(['members', 'common']);
  const { data } = useSuspenseQuery<CurrentUserMembersQuery>(CurrentUserMembersDocument);

  const member = data.currentUserMembers[0];

  if (!member) {
    throw notFound();
  }

  return (
    <PageBodyContainer>
      <div className="sm:p-8 p-4 flex justify-center items-center flex-col w-full">
        <div className="max-w-3xl w-full space-y-4 px-8 pb-8 bg-card shadow-lg rounded-xl justify-center ">
          <div className="flex justify-center pt-4">
            <h4 className="text-lg font-bold text-center">
              {t('members:complete-profile-page.title')}
            </h4>
          </div>
          <CompleteMemberProfile member={member} />
        </div>
      </div>
    </PageBodyContainer>
  );
}
